/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useGetTextMessage = () => useApi(`/v2/text-message`, 'GET', {}, {}, true);

export const useGetTextMessageByDomainType = (domainType) => useApi(`/v2/text-message/${domainType}`, 'GET', {}, {}, true);